module.exports = ["Project Management","Engineer","Supervisor","Admin","Worker","Senior Management"]


//////////////////
// WEBPACK FOOTER
// ./static/userProfile/workForceCategory.json
// module id = ./static/userProfile/workForceCategory.json
// module chunks = 12 14